import { lazy, Suspense } from 'react'
import RouteLoader from 'components/Loader/RouteLoader'

// Utility function to create lazy-loaded components with Suspense
export const createLazyRoute = (importFunction, loadingMessage = 'Loading...') => {
  const LazyComponent = lazy(importFunction)

  return (props) => (
    <Suspense fallback={<RouteLoader message={loadingMessage} />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}

// Route-specific loading messages
export const LOADING_MESSAGES = {
  AUTH: 'Loading authentication...',
  EMPLOYER: 'Loading employer dashboard...',
  CONTRACTOR: 'Loading job seeker dashboard...',
  PROFILE: 'Loading profile...',
  MESSAGES: 'Loading messages...',
  SETTINGS: 'Loading settings...',
  JOBS: 'Loading jobs...',
  CANDIDATES: 'Loading candidates...',
  PUBLIC: 'Loading page...',
  HELP: 'Loading help...',
}
